import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AlertsService } from '../../alerts-custom.service';
import { AlertsvarService } from '../../alertsvar.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-add-notes',
  templateUrl: './add-notes.component.html',
  styleUrls: ['./add-notes.component.scss']
})
export class AddNotesComponent implements OnInit, OnDestroy {


  $destroy: Subject<boolean> = new Subject()

  
  selectedNote:string = "";
  filteredNotes = [];
  addNoteSpinnerState:boolean = false;
  

  constructor(
    @Inject (MAT_DIALOG_DATA) public data:any,
    private ref:MatDialogRef<AddNotesComponent>,
    private alertService:AlertsService,
    public alertVarService:AlertsvarService,
    private sharedService:SharedService,
  ){}

  searchValue = new FormControl('');
  // notes = new FormControl('');
 

  ngOnInit(): void {
//console.log('*****AddNotes',this.data);
    this.filteredNotes = this.data.addNotesList
    this.searchValue.valueChanges.subscribe((searchstr) => {
      this.filteredNotes = [
        ...this.data.addNotesList.filter((item: any) => {
          return item.toLowerCase().includes(searchstr.toLowerCase())
        }),
      ]
    })
  }

  selectNote(note:any){
//console.log('selectNote----',note);
    
    this.selectedNote = note;
  }

  
  cancelNotes(){
    this.ref.close();
  }

  submitNotes(){
    if(this.searchValue.getRawValue()){
      // postAddNotes
      this.addNoteSpinnerState = true;
      const selectedAlert = [];
      this.data.selectedAlert.forEach((element:number)=>{
        selectedAlert.push({
          alertTime:this.alertVarService.eventlist[element].alerttime,
          seq_no:this.alertVarService.eventlist[element].seq_no
        })
      })
      const assignReqObj = {
        username: this.sharedService.userName,
        selectedAlert,
        alertId:this.alertVarService.alertscollapsedata.selectedalert.alertId,
        notes:this.searchValue.getRawValue()
      }
      this.alertService.postAddNotes(assignReqObj)
      .pipe(takeUntil(this.$destroy))
      .subscribe((res)=>{
        this.addNoteSpinnerState = false;
        this.ref.close(true);
        this.alertVarService.createtoastmsg({
          type:"success",
          "text":"Add notes successfully"
        })
      },
      (err)=>{
        this.addNoteSpinnerState = false;
      })
      
    }  
  }

  submitAddNote(){
    if(this.selectedNote){
      this.addNoteSpinnerState = true;
      const selectedAlert = [];
      this.data.selectedAlert.forEach((element:number)=>{
        selectedAlert.push({
          alertTime:this.alertVarService.eventlist[element].alerttime,
          seq_no:this.alertVarService.eventlist[element].seq_no
        })
      })
      const addReqObj = {
        username: this.sharedService.userName,
        alertId:this.alertVarService.alertscollapsedata.selectedalert.alertId,
        selectedAlert,
        notes:this.selectedNote,
        
      }
      this.alertService.postAddNotes(addReqObj)
      .pipe(takeUntil(this.$destroy))
      .subscribe((res)=>{
        this.addNoteSpinnerState = false;
        this.ref.close(true);
        this.alertVarService.createtoastmsg({
          type:"success",
          "text":"Add notes successfully"
        })
      },
      (err)=>{
        this.addNoteSpinnerState = false;
      })
    }
  }

  updateEventList(){
    this.data.selectedAlert.forEach((element:number)=>{
      this.alertVarService.eventlist[element].added_to = this.selectedNote;
      this.alertVarService.eventlist[element].status = "inprogress";
    })
    //this.alertVarService.eventlist = [...this.alertVarService.eventlist];
  };

  ngOnDestroy(): void {
    this.$destroy.next(true);
  }

 
}
